import Vue from 'vue'
import Vuex from 'vuex'
import wire from './module/wire.js'
import elct from './module/elct.js'
import sim from './module/simultation.js'
import auth from './module/auth.js'
import home from './module/home.js'
import interval from './module/interval.js'
import socket from './module/socket.js'
// import miscoket from './module/micom/socket.js'

import * as mixin from '../mixins/elct.js'
import { cloneDeep } from 'lodash'
// import $ from 'jquery'
import { shallowDiff } from '../utils/diff'

// const SHOULD_MUTATIONS = ['wire/drawAllLines', 'elct/addUsingElct', 'elct/removeUsingElct', 'elct/updateElctValues']
const SHOULD_MUTATIONS = ['wire/drawAllLines', 'elct/addUsingElct', 'elct/removeUsingElcts', 'elct/updateElctsValues']

class UndoRedoHistory {
  store
  history = []
  currentIndex = -1

  init (store) {
    this.store = store
  }

  addState (state) {
    if (this.currentIndex + 1 < this.history.length) {
      this.history.splice(this.currentIndex + 1)
    }
    this.history.push(state)
    this.currentIndex += 1
  }

  undo () {
    if (this.currentIndex === 0) {
      // console.log('cannot undo on initial state.')
      return
    }
    this.currentIndex -= 1
    const prevState = cloneDeep(this.history[this.currentIndex])

    this.restoreComponents(prevState.elct.using, this.store.state.elct.using)

    this.store.replaceState(prevState)
  }

  redo () {
    if (this.currentIndex + 1 === this.history.length) {
      // console.log('no more state to redo. index: ', this.currentIndex)
      return
    }
    const next = cloneDeep(this.history[this.currentIndex + 1])

    this.restoreComponents(next.elct.using, this.store.state.elct.using)

    this.store.replaceState(next)
    this.currentIndex += 1
  }

  restoreComponents (_baseState, _targetState) {
    // console.log('restore attempted prev', JSON.stringify(targetState))
    // console.log('restore attempted current', JSON.stringify(_baseState))
    const baseState = cloneDeep(_baseState)
    const targetState = cloneDeep(_targetState)

    const diffResult = shallowDiff(targetState, baseState)
    if (diffResult) {
      // console.log('components changes:', JSON.stringify(diffResult))

      if (diffResult.added.length) {
        for (let i = 0; i < diffResult.added.length; i++) {
          const idx = diffResult.added[i]
          const compo = baseState[idx]
          const subdix = Object.keys(compo)[0]
          // console.log('add compo:', subdix, compo[subdix])
          this.insertCompnent(subdix, compo[subdix])
        }
      } else if (diffResult.deleted.length) {
        for (let i = 0; i < diffResult.deleted.length; i++) {
          const idx = diffResult.deleted[i]
          const compo = targetState[idx]
          const subdix = Object.keys(compo)[0]
          // console.log('delete compo:', subdix, compo[subdix])
          this.removeComponent(subdix, compo[subdix])
        }
      } else if (diffResult.updated.length) {
        for (let i = 0; i < diffResult.updated.length; i++) {
          const idx = diffResult.updated[i]

          // nested diff
          const subDiffResult = shallowDiff(targetState[idx], baseState[idx])
          // console.log('components changes(sub):', JSON.stringify(subDiffResult))
          if (subDiffResult.added.length) {
            for (let i = 0; i < subDiffResult.added.length; i++) {
              const sidx = subDiffResult.added[i]
              const compo = baseState[idx][sidx]
              // console.log('add compo(sub):', sidx, compo)
              this.insertCompnent(sidx, compo)
            }
          } else if (subDiffResult.deleted.length) {
            for (let i = 0; i < subDiffResult.deleted.length; i++) {
              const sidx = subDiffResult.deleted[i]
              const compo = targetState[idx][sidx]
              // console.log('delete compo(sub):', sidx, compo)
              this.removeComponent(sidx)
            }
          } else if (subDiffResult.updated.length) {
            for (let i = 0; i < subDiffResult.updated.length; i++) {
              const sidx = subDiffResult.updated[i]
              const compo = baseState[idx][sidx]
              // console.log('update compo(sub) base:', sidx, targetState[idx][sidx].pos)
              // console.log('update compo(sub) target:', sidx, compo.pos)
              mixin.elct.methods.updateElementPosition(sidx, compo.pos, this.store.$app)
            }
          }
        }
      }
      // for (const [key, value] of Object.entries(diffResult)) {
      //   console.log(key, JSON.stringify(value))
      // }
    }
  }

  insertCompnent (idx, compo) {
    const pos = {
      x: compo.pos.x,
      y: compo.pos.y
    }
    const compClassId = idx.substring(0, idx.indexOf('_'))
    mixin.elct.methods.createElctComponent(compClassId, 'load', pos, this.store.$app, idx)
    this.store.commit('elct/assignUsingCounts', compClassId, idx)
  }

  removeComponent (compId) {
    mixin.elct.methods.removeElctComponent(compId, this.store.$app)
    const compClassId = compId.substring(0, compId.indexOf('_'))
    this.store.commit('elct/dischargeUsingCounts', compClassId, compId)
  }


  // updateElements () {
  //   this.removeElements()
  //   this.createElements()
  // }

  // removeElements () {
  //   if (!this.store.state.elct.created.length) return
  //   const created = this.store.state.elct.created
  //   for (let i = created.length - 1; i >= 0; i--) {
  //     const elct = created[i]
  //     const el = $(`g#${elct.id}`)
  //     if (el) el.remove()
  //   }
  // }

  // createElements () {
  //   if (!this.store.state.elct.created.length) return
  //   console.log('redo[createElement]', this.store.state.elct.created)
  //   this.store.state.elct.created.forEach((elct) => {
  //     const el = $(`g#${elct.id}`)
  //     if (el) {
  //       const pos = {
  //         x: elct.el.getAttribute('x'),
  //         y: elct.el.getAttribute('y')
  //       }
  //       mixin.elct.methods.createElctComponent(elct.name, 'created', this.store.$app, pos)
  //     }
  //   })
  // }
}
const undoRedoHistory = new UndoRedoHistory()

const undoRedoPlugin = (store) => {
  undoRedoHistory.init(store)
  // const firstState = cloneDeep(store.state)
  // undoRedoHistory.addState(firstState)

  store.subscribe((mutation, state) => {
    if (mutation.type === 'undo') {
      undoRedoHistory.undo()
      // console.log('undo: wireList', JSON.stringify(store.state.wire.wireList))
      // console.log('undo: elct.using', JSON.stringify(store.state.elct.using))
    } else if (mutation.type === 'redo') {
      undoRedoHistory.redo()
      // console.log('redo: wireList', JSON.stringify(store.state.wire.wireList))
      // console.log('redo: elct.using', JSON.stringify(store.state.elct.using))
    } else if (mutation.type === 'initUndoRedo') {
      undoRedoHistory.addState(cloneDeep(state))
    } else if (SHOULD_MUTATIONS.includes(mutation.type)) {
      undoRedoHistory.addState(cloneDeep(state))
      // console.log(mutation.type, undoRedoHistory.history)
    }
  })
}

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false,
  state: {
    svgpanzoom: null,
    isSimulating: false,
    isSensor: false,
    valuebox: {
      resist: {
        toggle: false,
        id: 0
      },
      values: {
        toggle: false,
        id: 0,
        unit: '',
        code: ''
      }
    },
    timer: {
      interval: null,
      time: 0
    },
    warning: {
      display: false,
      message: '',
      timeout: 3000
    }
  },
  modules: {
    wire,
    elct,
    sim,
    auth,
    home,
    interval,
    socket
    // miscoket
  },
  plugins: [undoRedoPlugin],
  mutations: {
    initUndoRedo () {},
    undo () {},
    redo () {},
    // setVueInstance (state, vm) { // 안돼 쓰지마
    //   state.vm = vm
    // },
    setValueBox (state, payload) {
      setTimeout(() => {
        // wait for value box toggle changes
        const valuebox = document.querySelectorAll('#valuebox')
        // console.log("value box", valuebox[0])
        // console.log("all value boxes", valuebox)
        const tfields = valuebox[0].querySelector("input")
        // console.log("value box text-field", tfields)
        tfields.focus()
        tfields.select()
      }, 0);

      state.valuebox[payload.type] = payload
    },
    setSvgPanzoom (state, payload) {
      state.svgpanzoom = payload
    },
    setDefaultStates (state) {
      const states = undoRedoHistory.history[0]
      this.state.elct = cloneDeep(states.elct)
      this.state.wire = cloneDeep(states.wire)
      this.state.sim = cloneDeep(states.sim)
      this.state.valuebox = cloneDeep(states.valuebox)
      this.state.isSimulating = false
    },
    displayWarningBar (state, message) {
      state.warning.message = message
      state.warning.display = true
    },
    checkSensorType (state, type) {
      // part => sensor
      state.isSensor = (type === 'sensor')
    },
    startSimulation (state) {
      state.isSimulating = true
      this.dispatch('sim/sendSimulationData')
      this.dispatch('startTimer')
      // this.dispatch('sim/sendSimulationDataToSocket')
    },
    stopSimulation (state) {
      state.isSimulating = false
      this.dispatch('endTimer')
      this.commit('sim/removeHighLighting')
      this.commit('socket/disconnect')
    }
  },
  actions: {
    startTimer (context) {
      context.state.timer.interval = setInterval(() => {
        let ratio = context.state.sim.result.circuitinfo.time_ratio
        if (!ratio) ratio = 0.1
        context.state.timer.time = Math.round((context.state.timer.time + 0.1 * ratio) * 10000) / 10000
        // context.commit('interval/startAnimation')
      }, 100)
    },
    endTimer (context) {
      if (context.state.timer.interval) {
        clearInterval(context.state.timer.interval)
        context.state.timer.time = 0
        // context.commit('interval/stopAnimation')
      }
    }
  }
})
